module.exports = __webpack_public_path__ + "img/img-1.bba4fe67.png";